import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalFilePage } from './modal-file.page';

const routes: Routes = [
  {
    path: '',
    component: ModalFilePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalFilePageRoutingModule {}
